import { LinkButton, Search16 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './NewbuildingOnboardingButton.css';

export function NewbuildingOnboardingButton() {
  return (
    <div className={styles['onboarding-button_container']}>
      <LinkButton
        theme={'fill_white_primary'}
        href={'/newbuilding-wizard'}
        beforeIcon={<Search16 color={'primary_100'} />}
      >
        Пошаговый поиск квартиры в новостройке
      </LinkButton>
    </div>
  );
}
